import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SicotService } from '../sicot.service';
import { Struttura } from '../types/Struttura';

@Component({
    selector: 'app-struttura-dettaglio',
    imports: [HeaderComponent, FooterComponent, MatCardModule, MatProgressSpinnerModule, MatButtonModule, MatIconModule],
    templateUrl: './struttura-dettaglio.component.html',
    styleUrl: './struttura-dettaglio.component.css'
})
export class StrutturaDettaglioComponent implements OnInit {

    struttura: Struttura | null = null;
    fhirJson: object | null = null;
    /** JSON FHIR formattato per visualizzazione. */
    fhirJsonFormatted = '';
    caricamento = true;
    errore: string | null = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private sicotService: SicotService
    ) {}

    ngOnInit(): void {
        const id = this.route.snapshot.paramMap.get('id');
        if (!id) {
            this.errore = 'Id struttura non valido.';
            this.caricamento = false;
            return;
        }
        const idNum = Number(id);
        if (isNaN(idNum)) {
            this.errore = 'Id struttura non valido.';
            this.caricamento = false;
            return;
        }
        this.sicotService.getStruttura(idNum).subscribe({
            next: (data) => {
                this.struttura = data;
                if (data.fhirOrganizationJson) {
                    try {
                        this.fhirJson = JSON.parse(data.fhirOrganizationJson) as object;
                        this.fhirJsonFormatted = JSON.stringify(this.fhirJson, null, 2);
                    } catch {
                        this.fhirJson = null;
                        this.fhirJsonFormatted = data.fhirOrganizationJson;
                    }
                } else {
                    this.fhirJson = null;
                    this.fhirJsonFormatted = '';
                }
                this.caricamento = false;
            },
            error: () => {
                this.errore = 'Struttura non trovata.';
                this.caricamento = false;
            }
        });
    }

    goBack(): void {
        this.router.navigate(['/punti-erogazione-2']);
    }
}
